import React from 'react';
import CenterStatistic from '../components/CenterStatistic';
import TopStatistic from '../components/TopStatistic';
import BotttomStatistic from '../components/BotttomStatistic';

function Home(props) {

    return (
        <div className='home'>
            <div className="right">
                <TopStatistic />
                <CenterStatistic />
                <BotttomStatistic/>
            </div>
        </div>
    );
}

export default Home;